namespace Matrix.Workflow {
    export interface WorkflowQueueRetrieveResponse extends Serenity.RetrieveResponse<WorkflowInstanceRow> {
        Actions?: ClientFunctionTriggerRow[];
    }
}
